(function (Drupal) {
  Drupal.behaviors.weather = {
    attach: function(context,settings) {

      // https://www.weatherapi.com/docs/
      // https://api.weatherapi.com/v1/forecast.json?q=Moscow&days=7&key=8f2e8f9361f6463a80660632231107&lang=ru

      window.addEventListener('DOMContentLoaded', function() {

        const apiKey = '8f2e8f9361f6463a80660632231107';
        const cities = [
          { id: 'krasnodar', name: 'Krasnodar', translation: 'Краснодар' },
          { id: 'moscow', name: 'Moscow', translation: 'Москва' },
          { id: 'rostov', name: 'Rostov', translation: 'Ростов-на-Дону' },
          { id: 'sochi', name: 'Sochi', translation: 'Сочи' },
          { id: 'saint-petersburg', name: 'Saint-Petersburg', translation: 'Санкт-Петербург' },
          { id: 'vladivostok', name: 'Vladivostok', translation: 'Владивосток' },
          { id: 'novosibirsk', name: 'Novosibirsk', translation: 'Новосибирск' }
        ];
        const lang = 'ru';

        cities.forEach(function(city) {
          let url = 'https://api.weatherapi.com/v1/forecast.json?q=' + city.name + '&days=7&key=' + apiKey + '&lang=' + lang;

          fetch(url)
            .then(function(response) {
              return response.json();
            })
            .then(function(data) {
              let temperature = data.current.temp_c;
              let description = data.current.condition.text;
              let iconUrl = 'https:' + data.current.condition.icon;
              let windSpeed = data.current.wind_kph;
              let pressure = data.current.pressure_mb;
              let humidity = data.current.humidity;
              let cityElements = document.getElementsByClassName('city');
              for (let i = 0; i < cityElements.length; i++) {
                let dataCity = cityElements[i].getAttribute('data-city');
                if (dataCity === city.name) {
                  cityElements[i].innerHTML = '' +
                    '<div class="row text-center justify-content-center align-items-center">' +
                    '<div class="col-12">' +
                    '<div class="h4 mb-3">' + city.translation + '</div>' +
                    '</div>' +
                    '<div class="col-auto col-xl-4"><p><i class="fa-light fa-temperature-high"></i> ' +
                    '<span class="fs-2 fw-bolder text-info-emphasis">' + temperature + '<span>°C</p></div>' +
                    '<div class="col-auto col-xl-3"><img class="city-weather--image" src="' + iconUrl + '" alt="Weather icon"></div>' +
                    '<div class="col-12 col-xl-4 mb-3"><p class="fst-italic text-secondary">' + description + '</p></div>' +
                    '<div class="col-auto col-xl-4 mt-2"><p><i class="fa-light fa-wind text-info-emphasis me-1"></i> ' + windSpeed + ' км/ч</p></div>' +
                    '<div class="col-auto col-xl-4 mt-2"><p><i class="fa-light fa-raindrops text-info-emphasis me-1"></i> ' + humidity + '%</p></div>' +
                    '<div class="col-auto col-xl-4 mt-2"><p><i class="fa-light fa-gauge-simple-high text-info-emphasis me-1"></i> ' + pressure + ' Мбар</p></div>' +
                    '</div>';
                }
              }
            })
            .catch(function(error) {
              console.log('Error:', error);
            });
        });
      });

    }
  };
})(Drupal);
